module.exports = __webpack_public_path__ + "img/success.62ac4463.svg";